//  Modules from the React eco-system
import { useState, useEffect, useContext } from "react"

// Own components
import SubPageNavbar from "../components/navigation/subpage-navbar.component"

// Navigation
import { Route, Switch, useHistory } from "react-router-dom"
import cubesMainRoutes from "../routes/mains/cubes-main.route"

// Axios
import axiosClient from "../api/api"

// Redux, store
import { setPageName } from "../store/pageSlice"
import { useDispatch } from "react-redux"
import { UserContext } from "../store/UserProvider"

// Interfaces, enums
import { ICube } from "../interfaces/cubes"
import { ISubPageRoute } from "../interfaces/pages"
import Loader from "../components/loader.component"
import { ERoles } from "../constants/enum"

/**
 * cubes page
 * @returns
 */
function Cubes() {
    //Logged in user
    const { user } = useContext(UserContext)

    // dispatch for the redux
    const dispatch = useDispatch()

    const history = useHistory()

    // cubes from the fetch
    const [cubes, setCubes] = useState<ICube[]>([])

    const [isLoading, setisLoading] = useState(true)

    useEffect(() => {
        // set page name
        dispatch(setPageName({ pageName: "Spots", pageUrl: "/admin/cubes/main", subPageName: "" }))

        // fetch cubes
        fetchCubes()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    /**
     * fetch cubes from the backend
     */
    async function fetchCubes() {
        setisLoading(true)
        try {
            const response = await axiosClient.get("/spot/list")
            setCubes(response.data)
        } catch (error) {
            console.log("Failed to fetch Spots")
            history.push("/admin/404")
        }
        setisLoading(false)
    }

    return (
        <div>
            {isLoading ? (
                <Loader />
            ) : (
                <>
                    <SubPageNavbar
                        routes={cubesMainRoutes.filter((route: ISubPageRoute) => {
                            return route.permission?.includes(user.role as ERoles)
                        })}
                    />
                    <Switch>
                        {cubesMainRoutes
                            .filter((route: ISubPageRoute) => {
                                return route.permission?.includes(user.role as ERoles)
                            })
                            .map((route: ISubPageRoute, key: number) => {
                                return (
                                    <Route
                                        key={key}
                                        path={route.path}
                                        exact
                                        render={() => {
                                            return (
                                                <div>
                                                    <route.component cubes={cubes} setRegions={cubes} {...route.props} />
                                                </div>
                                            )
                                        }}
                                    />
                                )
                            })}
                    </Switch>
                </>
            )}
        </div>
    )
}

export default Cubes
